module.exports = __webpack_public_path__ + "img/identitiet-image.c61991cb.png";